import React from "react";

function PrivacyPolicy({ onBack }) {
  return (
    <div className="landing-container">
      <header className="landing-header">
        <div className="landing-title-group">
          <h1 className="landing-title">
            Privacy <span className="highlight">Policy</span>
          </h1>
          <h2 className="landing-subtitle">Santa Thadeu Health Services</h2>
        </div>
      </header>
      <main className="landing-main">
        <p className="policy-date">Last Updated: 12 June 2026</p>
        <section className="policy-card">
          <p>
            <p>
              This Privacy Policy explains how Santa Thadeu Health Services
              collects, uses, stores, and protects personal information obtained
              through our website, and digital communication channels, including
              WhatsApp.
            </p>
          </p>
        </section>

        <section className="policy-card">
          <h3>Health Services and WhatsApp Services</h3>
          <p>
            Santa Thadeu Health Services may collect personal information
            through its healthcare systems, membership platforms, and WhatsApp
            services. This information may include names, phone numbers, dates
            of birth, national identification numbers, beneficiary information,
            appointment details, and payment-related information where necessary
            to provide requested services.
          </p>
        </section>

        <section className="policy-card">
          <h3>How We Use Information</h3>
          <p>
            We use personal information to provide healthcare-related services,
            process membership registrations, manage beneficiaries, schedule
            appointments, process payments, communicate with patients and
            members, provide customer support, and improve our services.
          </p>
        </section>

        <section className="policy-card">
          <h3>Cookies and Tracking</h3>
          <p>
            The website may use cookies and similar technologies to support site
            functionality, remember preferences, and analyze traffic. You can
            manage cookies through your browser settings.
          </p>
        </section>

        <section className="policy-card">
          <h3>Third-Party Links</h3>
          <p>
            Our website may contain links to third-party services such as
            WhatsApp. These links are provided for convenience. We are not
            responsible for the privacy practices of external websites.
          </p>
        </section>

        <section className="policy-card">
          <h3>Security</h3>
          <p>
            We take reasonable steps to protect information from unauthorized
            access or disclosure, but no Internet transmission is completely
            secure.
          </p>
        </section>

        <section className="policy-card">
          <h3>Changes to This Policy</h3>
          <p>
            We may update this policy from time to time. Changes will be posted
            on this page and will apply from the date of publication.
          </p>
        </section>

        <section className="policy-card">
          <h3>Data Retention</h3>
          <p>
            We retain personal information only for as long as necessary to
            provide services, comply with legal obligations, resolve disputes,
            and maintain business records.
          </p>
        </section>

        <section className="policy-card">
          <h3>Your Rights</h3>
          <p>
            You may request access to, correction of, or deletion of your
            personal information by contacting us using the details below,
            subject to applicable legal and regulatory requirements.
          </p>
          <p>
            For detailed instructions on how to delete your data, visit the
            <a className="privacy-link" href="#data-delete">
              Data Deletion page
            </a>
            .
          </p>
        </section>

        <section className="policy-card">
          <h3>Contact</h3>
          <p>
            If you have questions about this policy, please contact us at
            <br />
            <a href="mailto:admin@santathadeu.co.zw">admin@santathadeu.co.zw</a>
          </p>
        </section>

        <button className="privacy-back" onClick={onBack}>
          Back to Home
        </button>
      </main>
      <footer className="landing-footer">
        <p>
          &copy; {new Date().getFullYear()} Santa Thadeu Health Services. All
          rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default PrivacyPolicy;
